import React from "react";

import { Spinner } from "@treelab/panda";

import { Container } from "./styled";

const Loading: React.FC = () => {
  return (
    <Container>
      <Spinner itemSize="medium" />
    </Container>
  );
};

export default Loading;
